module.exports = __webpack_public_path__ + "img/vacation-for-good.b60f4235.png";